<template>
  <button
    :class="['base-button', isDisabled ? 'disabled' : '']"
    :disabled="isDisabled"
  >
    {{ buttonLabel }}
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoginButton",
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    buttonLabel: {
      type: String,
      default: "Botón",
    },
  },
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/controls/loginButton";
</style>
